import React, { useState } from "react";
import FullWidthTextField from "../../../components/TextField/FullWidthTextField";
import { editiconorange } from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import { useTheme } from "@emotion/react";

const EditOwnerName = ({ lightTheme, value, onChange, error }) => {
    const { theme } = useTheme();
  return (
    <div className="field_wrapper padding_right disabled_field">
      <TextFieldWithIcon
        icon={editiconorange}
        label="Edit Owner/Founder Name"
        disabled={false}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        lightTheme={lightTheme}
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default EditOwnerName;
